/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetBulkScheduledMessageByIdDto } from '../models/custom-result-of-get-bulk-scheduled-message-by-id-dto';
import { CustomResultOfGetScheduledMessageAndBulkRecipientsByIdDto } from '../models/custom-result-of-get-scheduled-message-and-bulk-recipients-by-id-dto';
import { CustomResultOfGetScheduledMessageByIdDto } from '../models/custom-result-of-get-scheduled-message-by-id-dto';
import { CustomResultOfGetScheduledMessageByPhonebookCalculationsDto } from '../models/custom-result-of-get-scheduled-message-by-phonebook-calculations-dto';
import { CustomResultOfGetScheduledMessageCalculationByIdDto } from '../models/custom-result-of-get-scheduled-message-calculation-by-id-dto';
import { CustomResultOfGetScheduledMessageCalculationsByBulkDto } from '../models/custom-result-of-get-scheduled-message-calculations-by-bulk-dto';
import { CustomResultOfGetScheduledMessageCalculationsDto } from '../models/custom-result-of-get-scheduled-message-calculations-dto';
import { CustomResultOfGetSmartScheduledMessageByIdDto } from '../models/custom-result-of-get-smart-scheduled-message-by-id-dto';
import { CustomResultOfListOfGetLastLimitedCurrentUserScheduledMessagesDto } from '../models/custom-result-of-list-of-get-last-limited-current-user-scheduled-messages-dto';
import { CustomResultOfListOfSmartScheduledMessageCalculationsDto } from '../models/custom-result-of-list-of-smart-scheduled-message-calculations-dto';
import { CustomResultOfPaginatedListOfGetCurrentUserQueueWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-current-user-queue-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetResellerQueueWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-reseller-queue-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetUserQueueWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-user-queue-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetUsersQueueWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-users-queue-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { scheduledMessagesAddExistScheduledMessageToJobGet } from '../fn/scheduled-messages/scheduled-messages-add-exist-scheduled-message-to-job-get';
import { ScheduledMessagesAddExistScheduledMessageToJobGet$Params } from '../fn/scheduled-messages/scheduled-messages-add-exist-scheduled-message-to-job-get';
import { scheduledMessagesAddExistScheduledMessageToJobPost } from '../fn/scheduled-messages/scheduled-messages-add-exist-scheduled-message-to-job-post';
import { ScheduledMessagesAddExistScheduledMessageToJobPost$Params } from '../fn/scheduled-messages/scheduled-messages-add-exist-scheduled-message-to-job-post';
import { scheduledMessagesAddP2PScheduledMessageToQueue } from '../fn/scheduled-messages/scheduled-messages-add-p-2-p-scheduled-message-to-queue';
import { ScheduledMessagesAddP2PScheduledMessageToQueue$Params } from '../fn/scheduled-messages/scheduled-messages-add-p-2-p-scheduled-message-to-queue';
import { scheduledMessagesAddScheduledMessageToFileSendQueue } from '../fn/scheduled-messages/scheduled-messages-add-scheduled-message-to-file-send-queue';
import { ScheduledMessagesAddScheduledMessageToFileSendQueue$Params } from '../fn/scheduled-messages/scheduled-messages-add-scheduled-message-to-file-send-queue';
import { scheduledMessagesConfirmScheduledMessageStatus } from '../fn/scheduled-messages/scheduled-messages-confirm-scheduled-message-status';
import { ScheduledMessagesConfirmScheduledMessageStatus$Params } from '../fn/scheduled-messages/scheduled-messages-confirm-scheduled-message-status';
import { scheduledMessagesCreateDynamicScheduledMessageGet } from '../fn/scheduled-messages/scheduled-messages-create-dynamic-scheduled-message-get';
import { ScheduledMessagesCreateDynamicScheduledMessageGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-dynamic-scheduled-message-get';
import { scheduledMessagesCreateDynamicScheduledMessagePost } from '../fn/scheduled-messages/scheduled-messages-create-dynamic-scheduled-message-post';
import { ScheduledMessagesCreateDynamicScheduledMessagePost$Params } from '../fn/scheduled-messages/scheduled-messages-create-dynamic-scheduled-message-post';
import { scheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet } from '../fn/scheduled-messages/scheduled-messages-create-fast-pattern-scheduled-message-by-phonebook-get';
import { ScheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-fast-pattern-scheduled-message-by-phonebook-get';
import { scheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost } from '../fn/scheduled-messages/scheduled-messages-create-fast-pattern-scheduled-message-by-phonebook-post';
import { ScheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost$Params } from '../fn/scheduled-messages/scheduled-messages-create-fast-pattern-scheduled-message-by-phonebook-post';
import { scheduledMessagesCreateFastScheduledMessageGet } from '../fn/scheduled-messages/scheduled-messages-create-fast-scheduled-message-get';
import { ScheduledMessagesCreateFastScheduledMessageGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-fast-scheduled-message-get';
import { scheduledMessagesCreateFastScheduledMessagePost } from '../fn/scheduled-messages/scheduled-messages-create-fast-scheduled-message-post';
import { ScheduledMessagesCreateFastScheduledMessagePost$Params } from '../fn/scheduled-messages/scheduled-messages-create-fast-scheduled-message-post';
import { scheduledMessagesCreateGet } from '../fn/scheduled-messages/scheduled-messages-create-get';
import { ScheduledMessagesCreateGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-get';
import { scheduledMessagesCreateP2PScheduledMessageGet } from '../fn/scheduled-messages/scheduled-messages-create-p-2-p-scheduled-message-get';
import { ScheduledMessagesCreateP2PScheduledMessageGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-p-2-p-scheduled-message-get';
import { scheduledMessagesCreateP2PScheduledMessagePost } from '../fn/scheduled-messages/scheduled-messages-create-p-2-p-scheduled-message-post';
import { ScheduledMessagesCreateP2PScheduledMessagePost$Params } from '../fn/scheduled-messages/scheduled-messages-create-p-2-p-scheduled-message-post';
import { scheduledMessagesCreatePost } from '../fn/scheduled-messages/scheduled-messages-create-post';
import { ScheduledMessagesCreatePost$Params } from '../fn/scheduled-messages/scheduled-messages-create-post';
import { scheduledMessagesCreateRegionalScheduledMessageGet } from '../fn/scheduled-messages/scheduled-messages-create-regional-scheduled-message-get';
import { ScheduledMessagesCreateRegionalScheduledMessageGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-regional-scheduled-message-get';
import { scheduledMessagesCreateRegionalScheduledMessagePost } from '../fn/scheduled-messages/scheduled-messages-create-regional-scheduled-message-post';
import { ScheduledMessagesCreateRegionalScheduledMessagePost$Params } from '../fn/scheduled-messages/scheduled-messages-create-regional-scheduled-message-post';
import { scheduledMessagesCreateScheduledMessageBulk2Get } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-bulk-2-get';
import { ScheduledMessagesCreateScheduledMessageBulk2Get$Params } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-bulk-2-get';
import { scheduledMessagesCreateScheduledMessageBulk2Post } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-bulk-2-post';
import { ScheduledMessagesCreateScheduledMessageBulk2Post$Params } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-bulk-2-post';
import { scheduledMessagesCreateScheduledMessageBulkGet } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-bulk-get';
import { ScheduledMessagesCreateScheduledMessageBulkGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-bulk-get';
import { scheduledMessagesCreateScheduledMessageBulkPost } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-bulk-post';
import { ScheduledMessagesCreateScheduledMessageBulkPost$Params } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-bulk-post';
import { scheduledMessagesCreateScheduledMessageByPhonebookGet } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-by-phonebook-get';
import { ScheduledMessagesCreateScheduledMessageByPhonebookGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-by-phonebook-get';
import { scheduledMessagesCreateScheduledMessageByPhonebookPost } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-by-phonebook-post';
import { ScheduledMessagesCreateScheduledMessageByPhonebookPost$Params } from '../fn/scheduled-messages/scheduled-messages-create-scheduled-message-by-phonebook-post';
import { scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet } from '../fn/scheduled-messages/scheduled-messages-create-tracking-number-p-2-p-scheduled-message-get';
import { ScheduledMessagesCreateTrackingNumberP2PScheduledMessageGet$Params } from '../fn/scheduled-messages/scheduled-messages-create-tracking-number-p-2-p-scheduled-message-get';
import { scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost } from '../fn/scheduled-messages/scheduled-messages-create-tracking-number-p-2-p-scheduled-message-post';
import { ScheduledMessagesCreateTrackingNumberP2PScheduledMessagePost$Params } from '../fn/scheduled-messages/scheduled-messages-create-tracking-number-p-2-p-scheduled-message-post';
import { scheduledMessagesDelete } from '../fn/scheduled-messages/scheduled-messages-delete';
import { ScheduledMessagesDelete$Params } from '../fn/scheduled-messages/scheduled-messages-delete';
import { scheduledMessagesDeleteList } from '../fn/scheduled-messages/scheduled-messages-delete-list';
import { ScheduledMessagesDeleteList$Params } from '../fn/scheduled-messages/scheduled-messages-delete-list';
import { scheduledMessagesGetCurrentUserQueueWithPagination } from '../fn/scheduled-messages/scheduled-messages-get-current-user-queue-with-pagination';
import { ScheduledMessagesGetCurrentUserQueueWithPagination$Params } from '../fn/scheduled-messages/scheduled-messages-get-current-user-queue-with-pagination';
import { scheduledMessagesGetLastLimitedCurrentUserScheduledMessages } from '../fn/scheduled-messages/scheduled-messages-get-last-limited-current-user-scheduled-messages';
import { ScheduledMessagesGetLastLimitedCurrentUserScheduledMessages$Params } from '../fn/scheduled-messages/scheduled-messages-get-last-limited-current-user-scheduled-messages';
import { scheduledMessagesGetRegionalScheduledMessageCalculation } from '../fn/scheduled-messages/scheduled-messages-get-regional-scheduled-message-calculation';
import { ScheduledMessagesGetRegionalScheduledMessageCalculation$Params } from '../fn/scheduled-messages/scheduled-messages-get-regional-scheduled-message-calculation';
import { scheduledMessagesGetResellerScheduledMessageWithPagination } from '../fn/scheduled-messages/scheduled-messages-get-reseller-scheduled-message-with-pagination';
import { ScheduledMessagesGetResellerScheduledMessageWithPagination$Params } from '../fn/scheduled-messages/scheduled-messages-get-reseller-scheduled-message-with-pagination';
import { scheduledMessagesGetScheduledMessageAndBulkRecipientsById } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-and-bulk-recipients-by-id';
import { ScheduledMessagesGetScheduledMessageAndBulkRecipientsById$Params } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-and-bulk-recipients-by-id';
import { scheduledMessagesGetScheduledMessageById } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-by-id';
import { ScheduledMessagesGetScheduledMessageById$Params } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-by-id';
import { scheduledMessagesGetScheduledMessageCalculationById } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculation-by-id';
import { ScheduledMessagesGetScheduledMessageCalculationById$Params } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculation-by-id';
import { scheduledMessagesGetScheduledMessageCalculations } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculations';
import { ScheduledMessagesGetScheduledMessageCalculations$Params } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculations';
import { scheduledMessagesGetScheduledMessageCalculationsByBulk } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculations-by-bulk';
import { ScheduledMessagesGetScheduledMessageCalculationsByBulk$Params } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculations-by-bulk';
import { scheduledMessagesGetScheduledMessageCalculationsByBulk2 } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculations-by-bulk-2';
import { ScheduledMessagesGetScheduledMessageCalculationsByBulk2$Params } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculations-by-bulk-2';
import { scheduledMessagesGetScheduledMessageCalculationsByPhonebook } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculations-by-phonebook';
import { ScheduledMessagesGetScheduledMessageCalculationsByPhonebook$Params } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-message-calculations-by-phonebook';
import { scheduledMessagesGetScheduledMessagesAudit } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-messages-audit';
import { ScheduledMessagesGetScheduledMessagesAudit$Params } from '../fn/scheduled-messages/scheduled-messages-get-scheduled-messages-audit';
import { scheduledMessagesGetSmartScheduledMessageCalculations } from '../fn/scheduled-messages/scheduled-messages-get-smart-scheduled-message-calculations';
import { ScheduledMessagesGetSmartScheduledMessageCalculations$Params } from '../fn/scheduled-messages/scheduled-messages-get-smart-scheduled-message-calculations';
import { scheduledMessagesGetUserQueueWithPagination } from '../fn/scheduled-messages/scheduled-messages-get-user-queue-with-pagination';
import { ScheduledMessagesGetUserQueueWithPagination$Params } from '../fn/scheduled-messages/scheduled-messages-get-user-queue-with-pagination';
import { scheduledMessagesGetUsersQueueWithPagination } from '../fn/scheduled-messages/scheduled-messages-get-users-queue-with-pagination';
import { ScheduledMessagesGetUsersQueueWithPagination$Params } from '../fn/scheduled-messages/scheduled-messages-get-users-queue-with-pagination';
import { scheduledMessagesRejectScheduledMessage } from '../fn/scheduled-messages/scheduled-messages-reject-scheduled-message';
import { ScheduledMessagesRejectScheduledMessage$Params } from '../fn/scheduled-messages/scheduled-messages-reject-scheduled-message';
import { scheduledMessagesResendScheduledMessage } from '../fn/scheduled-messages/scheduled-messages-resend-scheduled-message';
import { ScheduledMessagesResendScheduledMessage$Params } from '../fn/scheduled-messages/scheduled-messages-resend-scheduled-message';
import { scheduledMessagesUpdateDynamicScheduledMessageGet } from '../fn/scheduled-messages/scheduled-messages-update-dynamic-scheduled-message-get';
import { ScheduledMessagesUpdateDynamicScheduledMessageGet$Params } from '../fn/scheduled-messages/scheduled-messages-update-dynamic-scheduled-message-get';
import { scheduledMessagesUpdateDynamicScheduledMessagePut } from '../fn/scheduled-messages/scheduled-messages-update-dynamic-scheduled-message-put';
import { ScheduledMessagesUpdateDynamicScheduledMessagePut$Params } from '../fn/scheduled-messages/scheduled-messages-update-dynamic-scheduled-message-put';
import { scheduledMessagesUpdateGet } from '../fn/scheduled-messages/scheduled-messages-update-get';
import { ScheduledMessagesUpdateGet$Params } from '../fn/scheduled-messages/scheduled-messages-update-get';
import { scheduledMessagesUpdateP2PScheduledMessageGet } from '../fn/scheduled-messages/scheduled-messages-update-p-2-p-scheduled-message-get';
import { ScheduledMessagesUpdateP2PScheduledMessageGet$Params } from '../fn/scheduled-messages/scheduled-messages-update-p-2-p-scheduled-message-get';
import { scheduledMessagesUpdateP2PScheduledMessagePut } from '../fn/scheduled-messages/scheduled-messages-update-p-2-p-scheduled-message-put';
import { ScheduledMessagesUpdateP2PScheduledMessagePut$Params } from '../fn/scheduled-messages/scheduled-messages-update-p-2-p-scheduled-message-put';
import { scheduledMessagesUpdatePut } from '../fn/scheduled-messages/scheduled-messages-update-put';
import { ScheduledMessagesUpdatePut$Params } from '../fn/scheduled-messages/scheduled-messages-update-put';
import { scheduledMessagesUpdateScheduledMessageBulkGet } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-bulk-get';
import { ScheduledMessagesUpdateScheduledMessageBulkGet$Params } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-bulk-get';
import { scheduledMessagesUpdateScheduledMessageBulkPut } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-bulk-put';
import { ScheduledMessagesUpdateScheduledMessageBulkPut$Params } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-bulk-put';
import { scheduledMessagesUpdateScheduledMessageByPhonebookGet } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-by-phonebook-get';
import { ScheduledMessagesUpdateScheduledMessageByPhonebookGet$Params } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-by-phonebook-get';
import { scheduledMessagesUpdateScheduledMessageByPhonebookPut } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-by-phonebook-put';
import { ScheduledMessagesUpdateScheduledMessageByPhonebookPut$Params } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-by-phonebook-put';
import { scheduledMessagesUpdateScheduledMessageStatusForEdit } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-status-for-edit';
import { ScheduledMessagesUpdateScheduledMessageStatusForEdit$Params } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-status-for-edit';
import { scheduledMessagesUpdateScheduledMessageStatusReturnEdit } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-status-return-edit';
import { ScheduledMessagesUpdateScheduledMessageStatusReturnEdit$Params } from '../fn/scheduled-messages/scheduled-messages-update-scheduled-message-status-return-edit';
import { scheduledMessagesUpdateSmartScheduledMessageGet } from '../fn/scheduled-messages/scheduled-messages-update-smart-scheduled-message-get';
import { ScheduledMessagesUpdateSmartScheduledMessageGet$Params } from '../fn/scheduled-messages/scheduled-messages-update-smart-scheduled-message-get';
import { scheduledMessagesUpdateSmartScheduledMessagePut } from '../fn/scheduled-messages/scheduled-messages-update-smart-scheduled-message-put';
import { ScheduledMessagesUpdateSmartScheduledMessagePut$Params } from '../fn/scheduled-messages/scheduled-messages-update-smart-scheduled-message-put';
import { scheduledMessagesUploadFile } from '../fn/scheduled-messages/scheduled-messages-upload-file';
import { ScheduledMessagesUploadFile$Params } from '../fn/scheduled-messages/scheduled-messages-upload-file';
import { scheduledMessagesUserConfirmScheduledMessageStatus } from '../fn/scheduled-messages/scheduled-messages-user-confirm-scheduled-message-status';
import { ScheduledMessagesUserConfirmScheduledMessageStatus$Params } from '../fn/scheduled-messages/scheduled-messages-user-confirm-scheduled-message-status';

@Injectable({ providedIn: 'root' })
export class ScheduledMessagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `scheduledMessagesCreateGet()` */
  static readonly ScheduledMessagesCreateGetPath = '/ScheduledMessages/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateGet$Response(params?: ScheduledMessagesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateGet(params?: ScheduledMessagesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreatePost()` */
  static readonly ScheduledMessagesCreatePostPath = '/ScheduledMessages/Create';

  /**
   * Create ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreatePost$Response(params: ScheduledMessagesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreatePost(params: ScheduledMessagesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateFastScheduledMessageGet()` */
  static readonly ScheduledMessagesCreateFastScheduledMessageGetPath = '/ScheduledMessages/CreateFastScheduledMessage';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateFastScheduledMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateFastScheduledMessageGet$Response(params?: ScheduledMessagesCreateFastScheduledMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateFastScheduledMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateFastScheduledMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateFastScheduledMessageGet(params?: ScheduledMessagesCreateFastScheduledMessageGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateFastScheduledMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateFastScheduledMessagePost()` */
  static readonly ScheduledMessagesCreateFastScheduledMessagePostPath = '/ScheduledMessages/CreateFastScheduledMessage';

  /**
   * Create Fast ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateFastScheduledMessagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateFastScheduledMessagePost$Response(params: ScheduledMessagesCreateFastScheduledMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateFastScheduledMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Fast ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateFastScheduledMessagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateFastScheduledMessagePost(params: ScheduledMessagesCreateFastScheduledMessagePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateFastScheduledMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesResendScheduledMessage()` */
  static readonly ScheduledMessagesResendScheduledMessagePath = '/ScheduledMessages/ResendScheduledMessage';

  /**
   * Resend ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesResendScheduledMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesResendScheduledMessage$Response(params: ScheduledMessagesResendScheduledMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesResendScheduledMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * Resend ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesResendScheduledMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesResendScheduledMessage(params: ScheduledMessagesResendScheduledMessage$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesResendScheduledMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetUserQueueWithPagination()` */
  static readonly ScheduledMessagesGetUserQueueWithPaginationPath = '/ScheduledMessages/GetUserQueueWithPagination';

  /**
   * Get User Queue WithPagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetUserQueueWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetUserQueueWithPagination$Response(params: ScheduledMessagesGetUserQueueWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetUserQueueWithPaginationDto>> {
    return scheduledMessagesGetUserQueueWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Queue WithPagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetUserQueueWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetUserQueueWithPagination(params: ScheduledMessagesGetUserQueueWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetUserQueueWithPaginationDto> {
    return this.scheduledMessagesGetUserQueueWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetUserQueueWithPaginationDto>): CustomResultOfPaginatedListOfGetUserQueueWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetCurrentUserQueueWithPagination()` */
  static readonly ScheduledMessagesGetCurrentUserQueueWithPaginationPath = '/ScheduledMessages/GetCurrentUserQueueWithPagination';

  /**
   * Get Current User Queue with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetCurrentUserQueueWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetCurrentUserQueueWithPagination$Response(params: ScheduledMessagesGetCurrentUserQueueWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetCurrentUserQueueWithPaginationDto>> {
    return scheduledMessagesGetCurrentUserQueueWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Current User Queue with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetCurrentUserQueueWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetCurrentUserQueueWithPagination(params: ScheduledMessagesGetCurrentUserQueueWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetCurrentUserQueueWithPaginationDto> {
    return this.scheduledMessagesGetCurrentUserQueueWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetCurrentUserQueueWithPaginationDto>): CustomResultOfPaginatedListOfGetCurrentUserQueueWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetUsersQueueWithPagination()` */
  static readonly ScheduledMessagesGetUsersQueueWithPaginationPath = '/ScheduledMessages/GetUsersQueueWithPagination';

  /**
   * Get User Queue WithPagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetUsersQueueWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetUsersQueueWithPagination$Response(params: ScheduledMessagesGetUsersQueueWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetUsersQueueWithPaginationDto>> {
    return scheduledMessagesGetUsersQueueWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Queue WithPagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetUsersQueueWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetUsersQueueWithPagination(params: ScheduledMessagesGetUsersQueueWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetUsersQueueWithPaginationDto> {
    return this.scheduledMessagesGetUsersQueueWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetUsersQueueWithPaginationDto>): CustomResultOfPaginatedListOfGetUsersQueueWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetResellerScheduledMessageWithPagination()` */
  static readonly ScheduledMessagesGetResellerScheduledMessageWithPaginationPath = '/ScheduledMessages/GetResellerScheduledMessageWithPagination';

  /**
   * Get Reseller ScheduledMessage With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetResellerScheduledMessageWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetResellerScheduledMessageWithPagination$Response(params: ScheduledMessagesGetResellerScheduledMessageWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerQueueWithPaginationDto>> {
    return scheduledMessagesGetResellerScheduledMessageWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Reseller ScheduledMessage With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetResellerScheduledMessageWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetResellerScheduledMessageWithPagination(params: ScheduledMessagesGetResellerScheduledMessageWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetResellerQueueWithPaginationDto> {
    return this.scheduledMessagesGetResellerScheduledMessageWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerQueueWithPaginationDto>): CustomResultOfPaginatedListOfGetResellerQueueWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesDelete()` */
  static readonly ScheduledMessagesDeletePath = '/ScheduledMessages/Delete/{id}';

  /**
   * Delete ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesDelete$Response(params: ScheduledMessagesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesDelete(params: ScheduledMessagesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesDeleteList()` */
  static readonly ScheduledMessagesDeleteListPath = '/ScheduledMessages/DeleteList';

  /**
   * Delete ScheduledMessage By Id List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesDeleteList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesDeleteList$Response(params: ScheduledMessagesDeleteList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesDeleteList(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete ScheduledMessage By Id List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesDeleteList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesDeleteList(params: ScheduledMessagesDeleteList$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesDeleteList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetScheduledMessageById()` */
  static readonly ScheduledMessagesGetScheduledMessageByIdPath = '/ScheduledMessages/GetScheduledMessageById';

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetScheduledMessageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesGetScheduledMessageById$Response(params?: ScheduledMessagesGetScheduledMessageById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>> {
    return scheduledMessagesGetScheduledMessageById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetScheduledMessageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesGetScheduledMessageById(params?: ScheduledMessagesGetScheduledMessageById$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageByIdDto> {
    return this.scheduledMessagesGetScheduledMessageById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>): CustomResultOfGetScheduledMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateGet()` */
  static readonly ScheduledMessagesUpdateGetPath = '/ScheduledMessages/Update';

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateGet$Response(params?: ScheduledMessagesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>> {
    return scheduledMessagesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateGet(params?: ScheduledMessagesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageByIdDto> {
    return this.scheduledMessagesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>): CustomResultOfGetScheduledMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdatePut()` */
  static readonly ScheduledMessagesUpdatePutPath = '/ScheduledMessages/Update';

  /**
   * Update ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdatePut$Response(params: ScheduledMessagesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdatePut(params: ScheduledMessagesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateScheduledMessageBulkGet()` */
  static readonly ScheduledMessagesUpdateScheduledMessageBulkGetPath = '/ScheduledMessages/UpdateScheduledMessageBulk';

  /**
   * Get Bulk Scheduled Message By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateScheduledMessageBulkGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateScheduledMessageBulkGet$Response(params?: ScheduledMessagesUpdateScheduledMessageBulkGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetBulkScheduledMessageByIdDto>> {
    return scheduledMessagesUpdateScheduledMessageBulkGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Bulk Scheduled Message By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateScheduledMessageBulkGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateScheduledMessageBulkGet(params?: ScheduledMessagesUpdateScheduledMessageBulkGet$Params, context?: HttpContext): Observable<CustomResultOfGetBulkScheduledMessageByIdDto> {
    return this.scheduledMessagesUpdateScheduledMessageBulkGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetBulkScheduledMessageByIdDto>): CustomResultOfGetBulkScheduledMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateScheduledMessageBulkPut()` */
  static readonly ScheduledMessagesUpdateScheduledMessageBulkPutPath = '/ScheduledMessages/UpdateScheduledMessageBulk';

  /**
   * Update Scheduled Message Bulk.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateScheduledMessageBulkPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateScheduledMessageBulkPut$Response(params: ScheduledMessagesUpdateScheduledMessageBulkPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUpdateScheduledMessageBulkPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Scheduled Message Bulk.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateScheduledMessageBulkPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateScheduledMessageBulkPut(params: ScheduledMessagesUpdateScheduledMessageBulkPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUpdateScheduledMessageBulkPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateDynamicScheduledMessageGet()` */
  static readonly ScheduledMessagesUpdateDynamicScheduledMessageGetPath = '/ScheduledMessages/UpdateDynamicScheduledMessage';

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateDynamicScheduledMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateDynamicScheduledMessageGet$Response(params?: ScheduledMessagesUpdateDynamicScheduledMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>> {
    return scheduledMessagesUpdateDynamicScheduledMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateDynamicScheduledMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateDynamicScheduledMessageGet(params?: ScheduledMessagesUpdateDynamicScheduledMessageGet$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageByIdDto> {
    return this.scheduledMessagesUpdateDynamicScheduledMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>): CustomResultOfGetScheduledMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateDynamicScheduledMessagePut()` */
  static readonly ScheduledMessagesUpdateDynamicScheduledMessagePutPath = '/ScheduledMessages/UpdateDynamicScheduledMessage';

  /**
   * Update Dynamic ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateDynamicScheduledMessagePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateDynamicScheduledMessagePut$Response(params: ScheduledMessagesUpdateDynamicScheduledMessagePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUpdateDynamicScheduledMessagePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Dynamic ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateDynamicScheduledMessagePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateDynamicScheduledMessagePut(params: ScheduledMessagesUpdateDynamicScheduledMessagePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUpdateDynamicScheduledMessagePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateP2PScheduledMessageGet()` */
  static readonly ScheduledMessagesUpdateP2PScheduledMessageGetPath = '/ScheduledMessages/UpdateP2PScheduledMessage';

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateP2PScheduledMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateP2PScheduledMessageGet$Response(params?: ScheduledMessagesUpdateP2PScheduledMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>> {
    return scheduledMessagesUpdateP2PScheduledMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateP2PScheduledMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateP2PScheduledMessageGet(params?: ScheduledMessagesUpdateP2PScheduledMessageGet$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageByIdDto> {
    return this.scheduledMessagesUpdateP2PScheduledMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>): CustomResultOfGetScheduledMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateP2PScheduledMessagePut()` */
  static readonly ScheduledMessagesUpdateP2PScheduledMessagePutPath = '/ScheduledMessages/UpdateP2PScheduledMessage';

  /**
   * Update P2P ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateP2PScheduledMessagePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateP2PScheduledMessagePut$Response(params: ScheduledMessagesUpdateP2PScheduledMessagePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUpdateP2PScheduledMessagePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update P2P ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateP2PScheduledMessagePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateP2PScheduledMessagePut(params: ScheduledMessagesUpdateP2PScheduledMessagePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUpdateP2PScheduledMessagePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateScheduledMessageByPhonebookGet()` */
  static readonly ScheduledMessagesUpdateScheduledMessageByPhonebookGetPath = '/ScheduledMessages/UpdateScheduledMessageByPhonebook';

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateScheduledMessageByPhonebookGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateScheduledMessageByPhonebookGet$Response(params?: ScheduledMessagesUpdateScheduledMessageByPhonebookGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>> {
    return scheduledMessagesUpdateScheduledMessageByPhonebookGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateScheduledMessageByPhonebookGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateScheduledMessageByPhonebookGet(params?: ScheduledMessagesUpdateScheduledMessageByPhonebookGet$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageByIdDto> {
    return this.scheduledMessagesUpdateScheduledMessageByPhonebookGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageByIdDto>): CustomResultOfGetScheduledMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateScheduledMessageByPhonebookPut()` */
  static readonly ScheduledMessagesUpdateScheduledMessageByPhonebookPutPath = '/ScheduledMessages/UpdateScheduledMessageByPhonebook';

  /**
   * Update ScheduledMessage By Phonebook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateScheduledMessageByPhonebookPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateScheduledMessageByPhonebookPut$Response(params: ScheduledMessagesUpdateScheduledMessageByPhonebookPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUpdateScheduledMessageByPhonebookPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ScheduledMessage By Phonebook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateScheduledMessageByPhonebookPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateScheduledMessageByPhonebookPut(params: ScheduledMessagesUpdateScheduledMessageByPhonebookPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUpdateScheduledMessageByPhonebookPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateSmartScheduledMessageGet()` */
  static readonly ScheduledMessagesUpdateSmartScheduledMessageGetPath = '/ScheduledMessages/UpdateSmartScheduledMessage';

  /**
   * دریافت صف ارسال هوشمند بر اساس شناسه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateSmartScheduledMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateSmartScheduledMessageGet$Response(params?: ScheduledMessagesUpdateSmartScheduledMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetSmartScheduledMessageByIdDto>> {
    return scheduledMessagesUpdateSmartScheduledMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت صف ارسال هوشمند بر اساس شناسه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateSmartScheduledMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesUpdateSmartScheduledMessageGet(params?: ScheduledMessagesUpdateSmartScheduledMessageGet$Params, context?: HttpContext): Observable<CustomResultOfGetSmartScheduledMessageByIdDto> {
    return this.scheduledMessagesUpdateSmartScheduledMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetSmartScheduledMessageByIdDto>): CustomResultOfGetSmartScheduledMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateSmartScheduledMessagePut()` */
  static readonly ScheduledMessagesUpdateSmartScheduledMessagePutPath = '/ScheduledMessages/UpdateSmartScheduledMessage';

  /**
   * ویرایش صف ارسال هوشمند بر اساس شناسه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateSmartScheduledMessagePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateSmartScheduledMessagePut$Response(params: ScheduledMessagesUpdateSmartScheduledMessagePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUpdateSmartScheduledMessagePut(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش صف ارسال هوشمند بر اساس شناسه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateSmartScheduledMessagePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateSmartScheduledMessagePut(params: ScheduledMessagesUpdateSmartScheduledMessagePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUpdateSmartScheduledMessagePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateScheduledMessageStatusForEdit()` */
  static readonly ScheduledMessagesUpdateScheduledMessageStatusForEditPath = '/ScheduledMessages/UpdateScheduledMessageStatusForEdit';

  /**
   * Update ScheduledMessage Status For Edit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateScheduledMessageStatusForEdit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateScheduledMessageStatusForEdit$Response(params: ScheduledMessagesUpdateScheduledMessageStatusForEdit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUpdateScheduledMessageStatusForEdit(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ScheduledMessage Status For Edit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateScheduledMessageStatusForEdit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateScheduledMessageStatusForEdit(params: ScheduledMessagesUpdateScheduledMessageStatusForEdit$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUpdateScheduledMessageStatusForEdit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUpdateScheduledMessageStatusReturnEdit()` */
  static readonly ScheduledMessagesUpdateScheduledMessageStatusReturnEditPath = '/ScheduledMessages/UpdateScheduledMessageStatusReturnEdit';

  /**
   * Update ScheduledMessage StatusReturn Edit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUpdateScheduledMessageStatusReturnEdit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateScheduledMessageStatusReturnEdit$Response(params: ScheduledMessagesUpdateScheduledMessageStatusReturnEdit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUpdateScheduledMessageStatusReturnEdit(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ScheduledMessage StatusReturn Edit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUpdateScheduledMessageStatusReturnEdit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUpdateScheduledMessageStatusReturnEdit(params: ScheduledMessagesUpdateScheduledMessageStatusReturnEdit$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUpdateScheduledMessageStatusReturnEdit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetScheduledMessageCalculationsByBulk()` */
  static readonly ScheduledMessagesGetScheduledMessageCalculationsByBulkPath = '/ScheduledMessages/GetScheduledMessageCalculationsByBulk';

  /**
   * Get ScheduledMessage Calculations ByBulk.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetScheduledMessageCalculationsByBulk()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculationsByBulk$Response(params: ScheduledMessagesGetScheduledMessageCalculationsByBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationsByBulkDto>> {
    return scheduledMessagesGetScheduledMessageCalculationsByBulk(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage Calculations ByBulk.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetScheduledMessageCalculationsByBulk$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculationsByBulk(params: ScheduledMessagesGetScheduledMessageCalculationsByBulk$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageCalculationsByBulkDto> {
    return this.scheduledMessagesGetScheduledMessageCalculationsByBulk$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationsByBulkDto>): CustomResultOfGetScheduledMessageCalculationsByBulkDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetRegionalScheduledMessageCalculation()` */
  static readonly ScheduledMessagesGetRegionalScheduledMessageCalculationPath = '/ScheduledMessages/GetRegionalScheduledMessageCalculation';

  /**
   * دریافت محاسبه هزینه ارسال منطقه ای.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetRegionalScheduledMessageCalculation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetRegionalScheduledMessageCalculation$Response(params: ScheduledMessagesGetRegionalScheduledMessageCalculation$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationsByBulkDto>> {
    return scheduledMessagesGetRegionalScheduledMessageCalculation(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت محاسبه هزینه ارسال منطقه ای.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetRegionalScheduledMessageCalculation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetRegionalScheduledMessageCalculation(params: ScheduledMessagesGetRegionalScheduledMessageCalculation$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageCalculationsByBulkDto> {
    return this.scheduledMessagesGetRegionalScheduledMessageCalculation$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationsByBulkDto>): CustomResultOfGetScheduledMessageCalculationsByBulkDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetScheduledMessageCalculationsByBulk2()` */
  static readonly ScheduledMessagesGetScheduledMessageCalculationsByBulk2Path = '/ScheduledMessages/GetScheduledMessageCalculationsByBulk2';

  /**
   * Get ScheduledMessage Calculations ByBulk2.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetScheduledMessageCalculationsByBulk2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculationsByBulk2$Response(params: ScheduledMessagesGetScheduledMessageCalculationsByBulk2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationsByBulkDto>> {
    return scheduledMessagesGetScheduledMessageCalculationsByBulk2(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage Calculations ByBulk2.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetScheduledMessageCalculationsByBulk2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculationsByBulk2(params: ScheduledMessagesGetScheduledMessageCalculationsByBulk2$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageCalculationsByBulkDto> {
    return this.scheduledMessagesGetScheduledMessageCalculationsByBulk2$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationsByBulkDto>): CustomResultOfGetScheduledMessageCalculationsByBulkDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetSmartScheduledMessageCalculations()` */
  static readonly ScheduledMessagesGetSmartScheduledMessageCalculationsPath = '/ScheduledMessages/GetSmartScheduledMessageCalculations';

  /**
   * Get Smart Calculations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetSmartScheduledMessageCalculations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetSmartScheduledMessageCalculations$Response(params: ScheduledMessagesGetSmartScheduledMessageCalculations$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfSmartScheduledMessageCalculationsDto>> {
    return scheduledMessagesGetSmartScheduledMessageCalculations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Smart Calculations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetSmartScheduledMessageCalculations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetSmartScheduledMessageCalculations(params: ScheduledMessagesGetSmartScheduledMessageCalculations$Params, context?: HttpContext): Observable<CustomResultOfListOfSmartScheduledMessageCalculationsDto> {
    return this.scheduledMessagesGetSmartScheduledMessageCalculations$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfSmartScheduledMessageCalculationsDto>): CustomResultOfListOfSmartScheduledMessageCalculationsDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetScheduledMessageCalculations()` */
  static readonly ScheduledMessagesGetScheduledMessageCalculationsPath = '/ScheduledMessages/GetScheduledMessageCalculations';

  /**
   * Get ScheduledMessage Calculations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetScheduledMessageCalculations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculations$Response(params: ScheduledMessagesGetScheduledMessageCalculations$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationsDto>> {
    return scheduledMessagesGetScheduledMessageCalculations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage Calculations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetScheduledMessageCalculations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculations(params: ScheduledMessagesGetScheduledMessageCalculations$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageCalculationsDto> {
    return this.scheduledMessagesGetScheduledMessageCalculations$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationsDto>): CustomResultOfGetScheduledMessageCalculationsDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetScheduledMessageCalculationsByPhonebook()` */
  static readonly ScheduledMessagesGetScheduledMessageCalculationsByPhonebookPath = '/ScheduledMessages/GetScheduledMessageCalculationsByPhonebook';

  /**
   * Get Scheduled Message Calculations By Phonebook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetScheduledMessageCalculationsByPhonebook()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculationsByPhonebook$Response(params: ScheduledMessagesGetScheduledMessageCalculationsByPhonebook$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageByPhonebookCalculationsDto>> {
    return scheduledMessagesGetScheduledMessageCalculationsByPhonebook(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Scheduled Message Calculations By Phonebook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetScheduledMessageCalculationsByPhonebook$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculationsByPhonebook(params: ScheduledMessagesGetScheduledMessageCalculationsByPhonebook$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageByPhonebookCalculationsDto> {
    return this.scheduledMessagesGetScheduledMessageCalculationsByPhonebook$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageByPhonebookCalculationsDto>): CustomResultOfGetScheduledMessageByPhonebookCalculationsDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetScheduledMessagesAudit()` */
  static readonly ScheduledMessagesGetScheduledMessagesAuditPath = '/ScheduledMessages/GetScheduledMessagesAudit';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetScheduledMessagesAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessagesAudit$Response(params: ScheduledMessagesGetScheduledMessagesAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return scheduledMessagesGetScheduledMessagesAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetScheduledMessagesAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessagesAudit(params: ScheduledMessagesGetScheduledMessagesAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.scheduledMessagesGetScheduledMessagesAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateScheduledMessageByPhonebookGet()` */
  static readonly ScheduledMessagesCreateScheduledMessageByPhonebookGetPath = '/ScheduledMessages/CreateScheduledMessageByPhonebook';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateScheduledMessageByPhonebookGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateScheduledMessageByPhonebookGet$Response(params?: ScheduledMessagesCreateScheduledMessageByPhonebookGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateScheduledMessageByPhonebookGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateScheduledMessageByPhonebookGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateScheduledMessageByPhonebookGet(params?: ScheduledMessagesCreateScheduledMessageByPhonebookGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateScheduledMessageByPhonebookGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateScheduledMessageByPhonebookPost()` */
  static readonly ScheduledMessagesCreateScheduledMessageByPhonebookPostPath = '/ScheduledMessages/CreateScheduledMessageByPhonebook';

  /**
   * Create Scheduled Message By Phonebook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateScheduledMessageByPhonebookPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateScheduledMessageByPhonebookPost$Response(params: ScheduledMessagesCreateScheduledMessageByPhonebookPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateScheduledMessageByPhonebookPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Scheduled Message By Phonebook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateScheduledMessageByPhonebookPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateScheduledMessageByPhonebookPost(params: ScheduledMessagesCreateScheduledMessageByPhonebookPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateScheduledMessageByPhonebookPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet()` */
  static readonly ScheduledMessagesCreateFastPatternScheduledMessageByPhonebookGetPath = '/ScheduledMessages/CreateFastPatternScheduledMessageByPhonebook';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet$Response(params?: ScheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet(params?: ScheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateFastPatternScheduledMessageByPhonebookGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost()` */
  static readonly ScheduledMessagesCreateFastPatternScheduledMessageByPhonebookPostPath = '/ScheduledMessages/CreateFastPatternScheduledMessageByPhonebook';

  /**
   * Create Fast Pattern Scheduled Message By Phonebook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost$Response(params: ScheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Fast Pattern Scheduled Message By Phonebook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost(params: ScheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateFastPatternScheduledMessageByPhonebookPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateScheduledMessageBulkGet()` */
  static readonly ScheduledMessagesCreateScheduledMessageBulkGetPath = '/ScheduledMessages/CreateScheduledMessageBulk';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateScheduledMessageBulkGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateScheduledMessageBulkGet$Response(params?: ScheduledMessagesCreateScheduledMessageBulkGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateScheduledMessageBulkGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateScheduledMessageBulkGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateScheduledMessageBulkGet(params?: ScheduledMessagesCreateScheduledMessageBulkGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateScheduledMessageBulkGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateScheduledMessageBulkPost()` */
  static readonly ScheduledMessagesCreateScheduledMessageBulkPostPath = '/ScheduledMessages/CreateScheduledMessageBulk';

  /**
   * Create ScheduledMessage Bulk.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateScheduledMessageBulkPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateScheduledMessageBulkPost$Response(params: ScheduledMessagesCreateScheduledMessageBulkPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateScheduledMessageBulkPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create ScheduledMessage Bulk.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateScheduledMessageBulkPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateScheduledMessageBulkPost(params: ScheduledMessagesCreateScheduledMessageBulkPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateScheduledMessageBulkPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateScheduledMessageBulk2Get()` */
  static readonly ScheduledMessagesCreateScheduledMessageBulk2GetPath = '/ScheduledMessages/CreateScheduledMessageBulk2';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateScheduledMessageBulk2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateScheduledMessageBulk2Get$Response(params?: ScheduledMessagesCreateScheduledMessageBulk2Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateScheduledMessageBulk2Get(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateScheduledMessageBulk2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateScheduledMessageBulk2Get(params?: ScheduledMessagesCreateScheduledMessageBulk2Get$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateScheduledMessageBulk2Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateScheduledMessageBulk2Post()` */
  static readonly ScheduledMessagesCreateScheduledMessageBulk2PostPath = '/ScheduledMessages/CreateScheduledMessageBulk2';

  /**
   * Create ScheduledMessage Bulk2.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateScheduledMessageBulk2Post()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateScheduledMessageBulk2Post$Response(params: ScheduledMessagesCreateScheduledMessageBulk2Post$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateScheduledMessageBulk2Post(this.http, this.rootUrl, params, context);
  }

  /**
   * Create ScheduledMessage Bulk2.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateScheduledMessageBulk2Post$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateScheduledMessageBulk2Post(params: ScheduledMessagesCreateScheduledMessageBulk2Post$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateScheduledMessageBulk2Post$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateRegionalScheduledMessageGet()` */
  static readonly ScheduledMessagesCreateRegionalScheduledMessageGetPath = '/ScheduledMessages/CreateRegionalScheduledMessage';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateRegionalScheduledMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateRegionalScheduledMessageGet$Response(params?: ScheduledMessagesCreateRegionalScheduledMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateRegionalScheduledMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateRegionalScheduledMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateRegionalScheduledMessageGet(params?: ScheduledMessagesCreateRegionalScheduledMessageGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateRegionalScheduledMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateRegionalScheduledMessagePost()` */
  static readonly ScheduledMessagesCreateRegionalScheduledMessagePostPath = '/ScheduledMessages/CreateRegionalScheduledMessage';

  /**
   * ایجاد ارسال منطقه ای.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateRegionalScheduledMessagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateRegionalScheduledMessagePost$Response(params: ScheduledMessagesCreateRegionalScheduledMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateRegionalScheduledMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد ارسال منطقه ای.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateRegionalScheduledMessagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateRegionalScheduledMessagePost(params: ScheduledMessagesCreateRegionalScheduledMessagePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateRegionalScheduledMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateP2PScheduledMessageGet()` */
  static readonly ScheduledMessagesCreateP2PScheduledMessageGetPath = '/ScheduledMessages/CreateP2PScheduledMessage';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateP2PScheduledMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateP2PScheduledMessageGet$Response(params?: ScheduledMessagesCreateP2PScheduledMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateP2PScheduledMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateP2PScheduledMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateP2PScheduledMessageGet(params?: ScheduledMessagesCreateP2PScheduledMessageGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateP2PScheduledMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateP2PScheduledMessagePost()` */
  static readonly ScheduledMessagesCreateP2PScheduledMessagePostPath = '/ScheduledMessages/CreateP2PScheduledMessage';

  /**
   * Create P2P ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateP2PScheduledMessagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateP2PScheduledMessagePost$Response(params: ScheduledMessagesCreateP2PScheduledMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateP2PScheduledMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create P2P ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateP2PScheduledMessagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateP2PScheduledMessagePost(params: ScheduledMessagesCreateP2PScheduledMessagePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateP2PScheduledMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet()` */
  static readonly ScheduledMessagesCreateTrackingNumberP2PScheduledMessageGetPath = '/ScheduledMessages/CreateTrackingNumberP2PScheduledMessage';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet$Response(params?: ScheduledMessagesCreateTrackingNumberP2PScheduledMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet(params?: ScheduledMessagesCreateTrackingNumberP2PScheduledMessageGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateTrackingNumberP2PScheduledMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost()` */
  static readonly ScheduledMessagesCreateTrackingNumberP2PScheduledMessagePostPath = '/ScheduledMessages/CreateTrackingNumberP2PScheduledMessage';

  /**
   * Create P2P ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost$Response(params: ScheduledMessagesCreateTrackingNumberP2PScheduledMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create P2P ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost(params: ScheduledMessagesCreateTrackingNumberP2PScheduledMessagePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateTrackingNumberP2PScheduledMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateDynamicScheduledMessageGet()` */
  static readonly ScheduledMessagesCreateDynamicScheduledMessageGetPath = '/ScheduledMessages/CreateDynamicScheduledMessage';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateDynamicScheduledMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateDynamicScheduledMessageGet$Response(params?: ScheduledMessagesCreateDynamicScheduledMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesCreateDynamicScheduledMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateDynamicScheduledMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesCreateDynamicScheduledMessageGet(params?: ScheduledMessagesCreateDynamicScheduledMessageGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesCreateDynamicScheduledMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesCreateDynamicScheduledMessagePost()` */
  static readonly ScheduledMessagesCreateDynamicScheduledMessagePostPath = '/ScheduledMessages/CreateDynamicScheduledMessage';

  /**
   * Create Dynamic ScheduledMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesCreateDynamicScheduledMessagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateDynamicScheduledMessagePost$Response(params: ScheduledMessagesCreateDynamicScheduledMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesCreateDynamicScheduledMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Dynamic ScheduledMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesCreateDynamicScheduledMessagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesCreateDynamicScheduledMessagePost(params: ScheduledMessagesCreateDynamicScheduledMessagePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesCreateDynamicScheduledMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetScheduledMessageAndBulkRecipientsById()` */
  static readonly ScheduledMessagesGetScheduledMessageAndBulkRecipientsByIdPath = '/ScheduledMessages/GetScheduledMessageAndBulkRecipientsById';

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetScheduledMessageAndBulkRecipientsById()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesGetScheduledMessageAndBulkRecipientsById$Response(params?: ScheduledMessagesGetScheduledMessageAndBulkRecipientsById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageAndBulkRecipientsByIdDto>> {
    return scheduledMessagesGetScheduledMessageAndBulkRecipientsById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetScheduledMessageAndBulkRecipientsById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesGetScheduledMessageAndBulkRecipientsById(params?: ScheduledMessagesGetScheduledMessageAndBulkRecipientsById$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageAndBulkRecipientsByIdDto> {
    return this.scheduledMessagesGetScheduledMessageAndBulkRecipientsById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageAndBulkRecipientsByIdDto>): CustomResultOfGetScheduledMessageAndBulkRecipientsByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesConfirmScheduledMessageStatus()` */
  static readonly ScheduledMessagesConfirmScheduledMessageStatusPath = '/ScheduledMessages/ConfirmScheduledMessageStatus';

  /**
   * Confirm Scheduled Message Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesConfirmScheduledMessageStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesConfirmScheduledMessageStatus$Response(params: ScheduledMessagesConfirmScheduledMessageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesConfirmScheduledMessageStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Confirm Scheduled Message Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesConfirmScheduledMessageStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesConfirmScheduledMessageStatus(params: ScheduledMessagesConfirmScheduledMessageStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesConfirmScheduledMessageStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesRejectScheduledMessage()` */
  static readonly ScheduledMessagesRejectScheduledMessagePath = '/ScheduledMessages/RejectScheduledMessage';

  /**
   * رد پیام های منتظر تایید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesRejectScheduledMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesRejectScheduledMessage$Response(params: ScheduledMessagesRejectScheduledMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesRejectScheduledMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * رد پیام های منتظر تایید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesRejectScheduledMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesRejectScheduledMessage(params: ScheduledMessagesRejectScheduledMessage$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesRejectScheduledMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUserConfirmScheduledMessageStatus()` */
  static readonly ScheduledMessagesUserConfirmScheduledMessageStatusPath = '/ScheduledMessages/UserConfirmScheduledMessageStatus';

  /**
   * تایید ارسال های منتظر تایید کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUserConfirmScheduledMessageStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUserConfirmScheduledMessageStatus$Response(params: ScheduledMessagesUserConfirmScheduledMessageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesUserConfirmScheduledMessageStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * تایید ارسال های منتظر تایید کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUserConfirmScheduledMessageStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesUserConfirmScheduledMessageStatus(params: ScheduledMessagesUserConfirmScheduledMessageStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesUserConfirmScheduledMessageStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesUploadFile()` */
  static readonly ScheduledMessagesUploadFilePath = '/ScheduledMessages/UploadFile';

  /**
   * Upload File.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesUploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  scheduledMessagesUploadFile$Response(params?: ScheduledMessagesUploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return scheduledMessagesUploadFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload File.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesUploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  scheduledMessagesUploadFile(params?: ScheduledMessagesUploadFile$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.scheduledMessagesUploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesAddExistScheduledMessageToJobGet()` */
  static readonly ScheduledMessagesAddExistScheduledMessageToJobGetPath = '/ScheduledMessages/AddExistScheduledMessageToJob';

  /**
   * بررسی دسترسی ساختن جاب برای پیام موجود در صف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesAddExistScheduledMessageToJobGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesAddExistScheduledMessageToJobGet$Response(params?: ScheduledMessagesAddExistScheduledMessageToJobGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return scheduledMessagesAddExistScheduledMessageToJobGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی ساختن جاب برای پیام موجود در صف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesAddExistScheduledMessageToJobGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesAddExistScheduledMessageToJobGet(params?: ScheduledMessagesAddExistScheduledMessageToJobGet$Params, context?: HttpContext): Observable<Blob> {
    return this.scheduledMessagesAddExistScheduledMessageToJobGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesAddExistScheduledMessageToJobPost()` */
  static readonly ScheduledMessagesAddExistScheduledMessageToJobPostPath = '/ScheduledMessages/AddExistScheduledMessageToJob';

  /**
   * ساختن جاب برای پیام موجود در صف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesAddExistScheduledMessageToJobPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesAddExistScheduledMessageToJobPost$Response(params?: ScheduledMessagesAddExistScheduledMessageToJobPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesAddExistScheduledMessageToJobPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ساختن جاب برای پیام موجود در صف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesAddExistScheduledMessageToJobPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesAddExistScheduledMessageToJobPost(params?: ScheduledMessagesAddExistScheduledMessageToJobPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesAddExistScheduledMessageToJobPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetLastLimitedCurrentUserScheduledMessages()` */
  static readonly ScheduledMessagesGetLastLimitedCurrentUserScheduledMessagesPath = '/ScheduledMessages/GetLastLimitedCurrentUserScheduledMessages';

  /**
   * دریافت آخرین کمپین های کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetLastLimitedCurrentUserScheduledMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesGetLastLimitedCurrentUserScheduledMessages$Response(params?: ScheduledMessagesGetLastLimitedCurrentUserScheduledMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetLastLimitedCurrentUserScheduledMessagesDto>> {
    return scheduledMessagesGetLastLimitedCurrentUserScheduledMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آخرین کمپین های کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetLastLimitedCurrentUserScheduledMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduledMessagesGetLastLimitedCurrentUserScheduledMessages(params?: ScheduledMessagesGetLastLimitedCurrentUserScheduledMessages$Params, context?: HttpContext): Observable<CustomResultOfListOfGetLastLimitedCurrentUserScheduledMessagesDto> {
    return this.scheduledMessagesGetLastLimitedCurrentUserScheduledMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetLastLimitedCurrentUserScheduledMessagesDto>): CustomResultOfListOfGetLastLimitedCurrentUserScheduledMessagesDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesGetScheduledMessageCalculationById()` */
  static readonly ScheduledMessagesGetScheduledMessageCalculationByIdPath = '/ScheduledMessages/GetScheduledMessageCalculationById';

  /**
   * دریافت محاسبه ارسال تکی بر اساس شناسه ارسال(مناسب ویرایش ).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesGetScheduledMessageCalculationById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculationById$Response(params: ScheduledMessagesGetScheduledMessageCalculationById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationByIdDto>> {
    return scheduledMessagesGetScheduledMessageCalculationById(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت محاسبه ارسال تکی بر اساس شناسه ارسال(مناسب ویرایش ).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesGetScheduledMessageCalculationById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesGetScheduledMessageCalculationById(params: ScheduledMessagesGetScheduledMessageCalculationById$Params, context?: HttpContext): Observable<CustomResultOfGetScheduledMessageCalculationByIdDto> {
    return this.scheduledMessagesGetScheduledMessageCalculationById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetScheduledMessageCalculationByIdDto>): CustomResultOfGetScheduledMessageCalculationByIdDto => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesAddP2PScheduledMessageToQueue()` */
  static readonly ScheduledMessagesAddP2PScheduledMessageToQueuePath = '/ScheduledMessages/AddP2PScheduledMessageToQueue';

  /**
   * افزودن ارسال نظیر به نظیر به صف پردازش شماره ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesAddP2PScheduledMessageToQueue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesAddP2PScheduledMessageToQueue$Response(params: ScheduledMessagesAddP2PScheduledMessageToQueue$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesAddP2PScheduledMessageToQueue(this.http, this.rootUrl, params, context);
  }

  /**
   * افزودن ارسال نظیر به نظیر به صف پردازش شماره ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesAddP2PScheduledMessageToQueue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesAddP2PScheduledMessageToQueue(params: ScheduledMessagesAddP2PScheduledMessageToQueue$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesAddP2PScheduledMessageToQueue$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `scheduledMessagesAddScheduledMessageToFileSendQueue()` */
  static readonly ScheduledMessagesAddScheduledMessageToFileSendQueuePath = '/ScheduledMessages/AddScheduledMessageToFileSendQueue';

  /**
   * افزودن ارسال تکی به صف استخراج شماره ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduledMessagesAddScheduledMessageToFileSendQueue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesAddScheduledMessageToFileSendQueue$Response(params: ScheduledMessagesAddScheduledMessageToFileSendQueue$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return scheduledMessagesAddScheduledMessageToFileSendQueue(this.http, this.rootUrl, params, context);
  }

  /**
   * افزودن ارسال تکی به صف استخراج شماره ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduledMessagesAddScheduledMessageToFileSendQueue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduledMessagesAddScheduledMessageToFileSendQueue(params: ScheduledMessagesAddScheduledMessageToFileSendQueue$Params, context?: HttpContext): Observable<CustomResult> {
    return this.scheduledMessagesAddScheduledMessageToFileSendQueue$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
